/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

// @ts-expect-error untyped
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import ModalDataTypes from 'ContentComponents/constants/ModalDataTypes';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error untyped
import { getContent } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getSiteSettings } from 'ContentEditorUI/redux/selectors/siteSettingsSelectors';
import { createSelector } from 'reselect';
import { Map as ImmutableMap, fromJS } from 'immutable';
// @ts-expect-error untyped
import { closeModal } from 'ContentEditorUI/redux/actions/appActions';
import useContentModalActions from 'ContentEditorUI/hooks/useContentModalActions';
import redirectToNewUrl from 'ContentEditorUI/utils/contentManagementPanel/redirectToNewUrl';
import ContentRoutes from 'ContentUtils/Routes';
import { ContentCategories } from 'FileManagerCore/Constants';
import { ContentTypes } from 'ContentComponents/constants/ContentActionModalContentTypes';
import { getIsSitePage } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { getHasAutotranslateAccess, getScopes, getGates } from 'ContentEditorUI/redux/selectors/authSelectors';
import UsageTracker, { useTracker } from 'ContentEditorUI/utils/UsageTracker';
import AsyncCreateCMPLanguageVariationModal from 'content-management-actions-lib/modals/AsyncCreateLanguageVariationModal';
import useContentCrmObject from 'ContentEditorUI/components/publishing/hooks/useContentCrmObject';
import { CONTENT_PLATFORM_PROPERTY_NAME, ContentObjectTypeProvider, ContentObjectTypes, getAssociatedContentTranslations, getContentPropertyValue, useContentObjectType } from 'content-management-data-lib';
import { EditorContentActionsProvider } from 'content-management-actions-lib/providers/ContentActionsProvider';
import ContentCrmObjectProvider from 'ContentEditorUI/components/publishing/ContentCrmObjectProvider';
import { getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { CONTENT_ACTION_IDS } from 'content-management-actions-lib/constants/actionIds';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
// @ts-expect-error Untyped module
import { showErrorWithHTML } from 'ContentEditorUI/utils/errorUtils';
import useAutotranslatePage from '../hooks/useAutotranslatePage';
import { WithUpdateDomainLanguageModal } from 'content-management-actions-lib/modals/WithUpdateDomainLanguageModal';
import AsyncPageLibCloneModal from 'page-lib/components/modals/AsyncClonePageModal';
import DeletePersonalizedPageModal from 'page-lib/components/modals/DeletePageModal';
import { getIsPersonalizedVariant, getIsUsingPersonalization } from '../redux/selectors/pageContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncDeletePageModal = makeAsyncComponent(() => import( /* webpackChunkName: 'DeletePageModal' */'./DeletePageModal'));
const AsyncTranslateContentActionModal = makeAsyncComponent(() => import( /* webpackChunkName: 'TranslateContentActionModal' */'ContentEditorUI/components/modals/TranslateContentActionModal'));
const AsyncContentRemixModal = makeAsyncComponent(() => import( /* webpackChunkName: 'ContentRemixModal' */'ContentComponents/components/contentActionModals/ContentRemixModal').then(result => result.default));
const CreateLanguageVariationModal = props => {
  const {
    contentObjectType
  } = useContentObjectType();
  const hasAutotranslateAccess = useSelector(getHasAutotranslateAccess);
  const isLandingPage = contentObjectType === ContentObjectTypes.LANDING_PAGE;
  const autotranslateUpgradePoint = isLandingPage ? 'landing-pages-create-multilanguage-variation-ai-translate' : 'site-pages-create-multilanguage-variation-ai-translate';
  const {
    openUpgradePage: openAutotranslateUpgradeModal
  } = useUpgradePoint(autotranslateUpgradePoint);
  const usageTracker = useTracker();
  const autotranslateAPIRequest = useAutotranslatePage({
    isLandingPage
  });
  return /*#__PURE__*/_jsx(AsyncCreateCMPLanguageVariationModal, Object.assign({}, props, {
    portalHasAutotranslateAccess: hasAutotranslateAccess,
    usageTracker: usageTracker,
    contentTypeHasAutotranslateFeature: true,
    openAutotranslateUpgradeModal: openAutotranslateUpgradeModal,
    autotranslateAPIRequest: autotranslateAPIRequest
  }));
};
const CreateLanguageVariationModalWrapper = props => {
  return /*#__PURE__*/_jsx(WithUpdateDomainLanguageModal, Object.assign({}, props, {
    MultiLangActionModal: CreateLanguageVariationModal
  }));
};
const PageLibCloneModalWrapper = props => {
  const tracker = useTracker();
  const handleTrack = useCallback(properties => {
    const eventKey = properties !== null && properties !== void 0 && properties.isAiGenerated ? 'clone-page-ai' : 'clone-page';
    tracker === null || tracker === void 0 || tracker.track('editorInteraction', {
      action: 'Content Management Action',
      event: eventKey
    });
  }, [tracker]);
  return /*#__PURE__*/_jsx(AsyncPageLibCloneModal, Object.assign({}, props, {
    onTrack: handleTrack,
    appReferrerName: "pageEditor"
  }));
};
const selectModalRelevantEntities = createSelector(getContent, content => {
  return ImmutableMap([[content.id, fromJS(content)]]);
});
const makeModalMap = ({
  isUsingPersonalization
}) => ({
  [MODAL_TYPES.CREATE_MLANG_VARIANT]: CreateLanguageVariationModalWrapper,
  [MODAL_TYPES.CONTENT_REMIX]: AsyncContentRemixModal,
  [MODAL_TYPES.TRANSLATE_CONTENT_ACTION_MODAL]: AsyncTranslateContentActionModal,
  [MODAL_TYPES.CLONE_CONTENT_MODAL]: PageLibCloneModalWrapper,
  [MODAL_TYPES.DELETE_MODAL]: isUsingPersonalization ? DeletePersonalizedPageModal : AsyncDeletePageModal
});
const noop = () => {};
const useModalActions = () => {
  const dispatch = useDispatch();
  const isSitePage = useSelector(getIsSitePage);
  const onDeletePage = useCallback(content => {
    let categoryId;
    if (content) {
      categoryId = content.categoryId;
    } else {
      categoryId = isSitePage ? ContentCategories.get(ContentTypes.SITE_PAGE) : ContentCategories.get(ContentTypes.LANDING_PAGE);
    }
    redirectToNewUrl(ContentRoutes.dashboard(categoryId));
  }, [isSitePage]);
  const {
    deleteContent
  } = useContentModalActions(onDeletePage, noop);
  const cloneCMPContent = useCallback(data => {
    const clonedPage = data === null || data === void 0 ? void 0 : data.completedResults[0];
    if (clonedPage) {
      const clonedId = clonedPage.objectId;
      redirectToNewUrl(ContentRoutes.edit(clonedId));
    }
  }, []);
  const createCMPTranslationVariation = useCallback(data => {
    var _data$actionData;
    const createdTranslationId = data === null || data === void 0 || (_data$actionData = data.actionData) === null || _data$actionData === void 0 ? void 0 : _data$actionData.objectId;
    if (createdTranslationId) {
      redirectToNewUrl(`${ContentRoutes.edit(createdTranslationId)}?redirectFromMultiLangVariationCreation=true`);
    }
  }, []);
  const actions = useMemo(() => ({
    deleteContent: page => {
      deleteContent(page);
    },
    cloneCMPContent,
    createCMPTranslationVariation,
    onClose: () => dispatch(closeModal()),
    closeModal: () => dispatch(closeModal())
  }), [deleteContent, createCMPTranslationVariation, cloneCMPContent, dispatch]);
  return actions;
};
const PageOperationsModalSwitch = ({
  openModalName
}) => {
  const modalActions = useModalActions();
  const modalRelevantEntities = useSelector(selectModalRelevantEntities);
  const siteSettings = useSelector(getSiteSettings);
  const hasAutotranslateAccess = useSelector(getHasAutotranslateAccess);
  const scopes = useSelector(getScopes);
  const gates = useSelector(getGates);
  const isLandingPage = useSelector(getIsLandingPage);
  const {
    contentCrmObject
  } = useContentCrmObject();
  const isUsingPersonalization = useSelector(getIsUsingPersonalization);
  const isPersonalizedVariant = useSelector(getIsPersonalizedVariant);
  const tracker = useTracker();
  const ModalMap = makeModalMap({
    isUsingPersonalization
  });
  const parentCrmObject = useMemo(() => {
    if (contentCrmObject) {
      const translatedFromId = getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID);
      if (translatedFromId) {
        const translations = getAssociatedContentTranslations(contentCrmObject);
        return translations.find(translation => `${translation.objectId}` === `${translatedFromId}`) || contentCrmObject;
      }
      return contentCrmObject;
    }
    return null;
  }, [contentCrmObject]);
  if (!openModalName || !ModalMap[openModalName]) {
    return null;
  }
  const PageOperationsModal = ModalMap[openModalName];
  return /*#__PURE__*/_jsx(EditorContentActionsProvider, {
    onActionError: ({
      actionId,
      error
    }) => {
      if (actionId === CONTENT_ACTION_IDS.CLONE) {
        showErrorWithHTML({
          response: error,
          action: 'clone-page'
        });
      } else if (actionId === CONTENT_ACTION_IDS.CREATE_LANGUAGE_VARIANT) {
        showErrorWithHTML({
          response: error,
          action: 'translate-page'
        });
      }
    },
    onActionSuccess: ({
      actionId,
      data
    }) => {
      switch (actionId) {
        case CONTENT_ACTION_IDS.CLONE:
          modalActions.cloneCMPContent(data);
          break;
        case CONTENT_ACTION_IDS.CREATE_LANGUAGE_VARIANT:
          modalActions.createCMPTranslationVariation(data);
          break;
        case CONTENT_ACTION_IDS.DELETE:
          if (isUsingPersonalization) {
            tracker === null || tracker === void 0 || tracker.track('editorInteraction', {
              action: 'Content Management Action',
              pageType: isLandingPage ? 'landing-page' : 'site-page',
              event: isPersonalizedVariant ? 'delete-personalized-content-variant' : 'delete-personalized-content-default'
            });
            redirectToNewUrl(ContentRoutes.dashboard(isLandingPage ? ContentCategories.get(ContentTypes.LANDING_PAGE) : ContentCategories.get(ContentTypes.SITE_PAGE)));
          }
          break;
        default:
          break;
      }
    },
    children: /*#__PURE__*/_jsx(PageOperationsModal, Object.assign({}, modalActions, {
      modalRelevantEntities: modalRelevantEntities,
      managementDataType: "pages",
      modalDataType: ModalDataTypes.PAGES,
      openModalName: openModalName,
      portalSettings: siteSettings,
      translationModalErrors: [],
      usageTracker: UsageTracker.tracker,
      portalHasAutotranslateAccess: hasAutotranslateAccess,
      crmObjects: parentCrmObject ? [parentCrmObject] : [],
      gates: gates,
      scopes: scopes
    }))
  });
};
const PageOperationsModalSwitchWrapper = ({
  openModalName
}) => {
  const isLandingPage = useSelector(getIsLandingPage);
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const contentCrmObjectId = useSelector(getContentModelId);
  const contentObjectType = useMemo(() => {
    if (isBlogListingPage) {
      return ContentObjectTypes.BLOG_LISTING_PAGE;
    }
    if (isLandingPage) {
      return ContentObjectTypes.LANDING_PAGE;
    }
    return ContentObjectTypes.SITE_PAGE;
  }, [isBlogListingPage, isLandingPage]);
  return /*#__PURE__*/_jsx(ContentCrmObjectProvider, {
    contentObjectType: contentObjectType,
    contentCrmObjectId: contentCrmObjectId,
    children: /*#__PURE__*/_jsx(ContentObjectTypeProvider, {
      contentObjectType: contentObjectType,
      children: /*#__PURE__*/_jsx(PageOperationsModalSwitch, {
        openModalName: openModalName
      })
    })
  });
};
export default PageOperationsModalSwitchWrapper;